interface LogoProps {
  href?: string;
}

function Logo({ href }: LogoProps) {
  // Determine the default href based on the current path
  const defaultHref =
    href ||
    (window.location.pathname.startsWith("/app")
      ? "/app/assessment"
      : "/console/all-assessments");

  return (
    <a href={defaultHref} className="flex content-center px-2 h-[40px]">
      <img src="/images/logo.png" alt="Logo" height={"40px"} />
    </a>
  );
}

export default Logo;
